import { render, staticRenderFns } from "./sysConfig.vue?vue&type=template&id=1aee4fc0&scoped=true&"
import script from "./sysConfig.vue?vue&type=script&lang=js&"
export * from "./sysConfig.vue?vue&type=script&lang=js&"
import style0 from "./sysConfig.vue?vue&type=style&index=0&id=1aee4fc0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aee4fc0",
  null
  
)

export default component.exports